export default __webpack_public_path__ + "static/media/asus.87387821.png";